import { render, staticRenderFns } from "./SettingsIcon.vue?vue&type=template&id=461c22ae&scoped=true&"
import script from "./SettingsIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SettingsIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c22ae",
  null
  
)

export default component.exports